import { render, staticRenderFns } from "./AdditionalFooter.vue?vue&type=template&id=4a930048&scoped=true&"
import script from "./AdditionalFooter.vue?vue&type=script&async=true&lang=js&"
export * from "./AdditionalFooter.vue?vue&type=script&async=true&lang=js&"
import style0 from "./AdditionalFooter.vue?vue&type=style&index=0&id=4a930048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a930048",
  null
  
)

export default component.exports